export default __webpack_public_path__ + "media/images/landing-18-550x420-3d0e912d5c35e860834bc655cf25a65c.jpg";